export default "__VITE_ASSET__DHpDcM63__"